export interface XolaBotPreference {
    id: ID;
    type: XolaBotPreferenceType | null;
    urls: string[];
}

export enum XolaBotPreferenceType {
    NONE = "",
    WHITELIST = "whitelist",
    BLACKLIST = "blacklist",
}
